<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar categoría" : "Nueva categoría" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{ editing ? "Datos de la categoría" : "Datos de la nueva categoría" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Nombre *</label>
                    <input
                      id="name"
                      type="text"
                      v-model="form.name"
                      autocomplete="off"
                      placeholder="Ingresar nombres"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.name.$error,
                      }"
                    />
                    <FormError
                      v-if="$v.form.name.$error && !$v.form.name.required"
                      message="Nombres son requeridos"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label for="description">Descripción *</label>
                    <textarea
                      id="description"
                      v-model="form.description"
                      placeholder="Ingresar descripción"
                      class="custom-form-control"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group-buttons text-right">
                    <router-link :to="{ name: 'config-category-list' }" class="button button-light">
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError, Constants } from "wize-admin";

import { CategoryService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    FormError
  },
  data() {
    return {
      profileTypes: [
        LocalConstants.ProfileTypes.ADMIN,
        LocalConstants.ProfileTypes.SUPERVISOR,
        LocalConstants.ProfileTypes.SUPER_ADMINISTRATOR,
      ],
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
      ],
      allProjectsSelected: false,
      form: {
        name: null,
        description: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      name: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {},
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
        };

        if (!this.editing) {
          await CategoryService.save(data);

          this.$router.push({
            name: "config-category-list",
          });
        } else {
          await CategoryService.update(this.$route.params.id, data);
          this.load(this.$route.params.id);
        }
        
        Alert.success("Se almacenó la información correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await CategoryService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "config-category-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
